/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_LoadingInputs */

const fr_plan_choice_loading = /** @type {(inputs: Plan_Choice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirection vers le paiement…`)
};

/**

* @param {Plan_Choice_LoadingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_loading = /** @type {((inputs?: Plan_Choice_LoadingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_LoadingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_loading(inputs)
});